(function () {
    'use strict';

    angular
        .module('AsyncPanel')
        .factory('action-get-panel-model', getPanelModel);

    function getPanelModel(lodash, PanelManager) {
        return function(options) {
            const panel_id = lodash.get(options, 'panel_id', false);
            if (!panel_id) return false;
            const panel = PanelManager.get(panel_id);
            return panel.getModel();
        };
    }
})();